<template>
    <section class="test-drive" >
        <PreviousStep />
        <div class="select-dealer__content">
        <div class="select-dealer__content-info">
            <selected-vehicle-details :model="model" :dealership="null"></selected-vehicle-details>
        </div>
        <div class="select-dealer__content-form" id="target-section" >
            <div class="select-dealer__content-search-container">
                <p class="select-dealer__content-search-title">Search for your dealer</p>
                <SearchDealer @postcodeSearch="updatePostcodeSearch" @place-updated="handlePlaceUpdate" />
            </div>
            <template v-if="postcodeSearch === true">
                <div class="select-dealer__content-grid">
                    <div class="card" v-for="dealership in closestDealers" :key="dealership.id">
                        <div class="card__inner select-dealer-card">
                            <div class="select-dealer-card__address">
                                <h3 class="select-dealer-card__title">Dealer Address</h3>
                                <p class="select-dealer-card__info">
                                    {{ dealership.name }} <br />
                                    {{ dealership.address }} <br />
                                    {{ dealership.postcode }}
                                </p>
                            </div>

                            <div class="select-dealer-card__logo">
                                <picture v-if="dealership.brand == 'abarth'">
                                    <source type="image/webp" :srcset="`/img/logos/borderless/${dealership.brand}.webp, /img/logos/borderless/${dealership.brand}@2x.webp 2x`">
                                    <img class="img-responsive" :src="`/img/logos/borderless/${dealership.brand}.jpg, /img/logos/borderless/${dealership.brand}@2x.jpg 2x`" :alt="dealership.brand">
                                </picture>
                                <img v-else class="img-responsive" :src="brandLogoPath(`/img/logos/borderless/${dealership.brand}.svg`)" :alt="dealership.brand" />
                            </div>

                            <button type="button" class="btn btn--primary-inverted select-dealer-card__cta" @click="selectDealer(dealership)">
                                Select this dealer
                            </button>
                        </div>
                    </div>
                </div>
                <div class="select-dealer__load-more">
                    <button type="button" class="btn btn--primary-inverted" @click="showMoreDealers" v-if="showLoadMoreLink">SHOW MORE</button>
                    <button type="button" class="btn btn--primary-inverted" @click="showLessDealers" v-else-if="showLessLink">SHOW LESS</button>
                </div>
            </template>
            <template v-else>
                <div class="select-dealer__help-container">
                    <img src="/images/info.svg" alt="" class="select-dealer__help-icon" />
                    <p class="select-dealer__help-text">Enter your town/postcode above and choose your address from the list in order to find your nearest dealership</p>
                </div>
            </template>
        </div>
    </div>

    </section>

</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import PreviousStep from "../PreviousStep";
import SearchDealer from "../SearchDealer.vue"
import SelectedVehicleDetails from "../SelectedVehicleDetails.vue"
import LoadingSpinner from "../../../../core/components/LoadingSpinner.vue";
import EventObject from "../../../../modules/tracking/EventObject";
import brandLogoPath from '../../../../modules/brandLogoPath';

export default {
    components: {
        SelectedVehicleDetails,
        PreviousStep,
        LoadingSpinner,
        SearchDealer,
    },
    data() {
        return {
            dealersToShow: 4,
            baseDealersToShow:4,
            postcodeSearch: 0,
            ignoreAvailability: true,
            availableDealerIds: [],
            error: false,
            loading: false,
        };
    },
    created() {
        this.$nextTick(() => {
            this.scrollToTop();
        });

        if (this.haveMinimumData == false) {
            this.$router.push({ name: 'select-options', params: {brand: brand, urlModel: this.urlModel}});
            return;
        }

        this.loading = true;
        this.initializeLocation({
            getAddressInfo: true,
            getPhoneInfo: true,
        });
    },
    computed: {
        ...mapState("Dealers", ["dealers"]),
        ...mapState(['dealerPage', 'scrollPosition']),
        ...mapGetters(["model","currentStep", 'currentOptions']),

        filteredDealers() {
            const filterBrand = (this.model.brand !== "") ? this.model.brand.toLowerCase() : window.model.brand.toLowerCase();
            return this.dealers.filter((dealer) => {
                if (this.ignoreAvailability == false && this.availableDealerIds.indexOf(dealer.id) === -1) {
                    return false;
                }
                return dealer.offers_new === "Y" && dealer.brand.toLowerCase() === filterBrand;
            });
        },
        closestDealers() {
            return this.filteredDealers.slice(0, this.dealersToShow);
        },

        showLoadMoreLink() {
            return this.closestDealers.length < this.filteredDealers.length;
        },
        showLessLink() {
            if(this.dealersToShow > 4 ){
                if((this.closestDealers.length > this.baseDealersToShow) && (this.closestDealers.length === this.filteredDealers.length)){
                    return true;
                }
            }
        },

    },
    methods: {
        brandLogoPath,
        ...mapActions("Dealers", ["initializeLocation"]),

        updatePostcodeSearch(value) {
            this.postcodeSearch = value;
            this.dealersToShow = 4;
        },

        handlePlaceUpdate(place) {
            if (typeof place.formatted_address != "undefined") {
                this.$store.commit("setCustomerAddress", { customerAddress: place.formatted_address });
            }
        },

        showMoreDealers() {
            this.dealersToShow += 4;
        },

        showLessDealers(){
            this.dealersToShow = 4;
        },

        selectDealer(dealership) {
            this.$store.dispatch("updateDealer", dealership );
        },
        scrollToTop() {
            const storedPosition = this.scrollPosition;
            if (storedPosition) {
                window.scrollTo({ top: storedPosition, behavior: 'smooth' });
            }
        },

    },
    mounted() {
        this.scrollToTop();
        window.scrollTo(0, 0);
    }
};
</script>

